import {
  FETCH_ASSET_GROUPS_REQUEST,
  FETCH_BUSINESS_FUNCTIONS_REQUEST,
} from "../types/business_functions";
import axiosInstance from "../../axios";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import { alertSuccess } from "../../utils/feedback";
import { claimOrgScopedRequest } from "./orgScopedRequest";

export const fetchBusinessFunctions = (businessFunctions) => ({
  type: FETCH_BUSINESS_FUNCTIONS_REQUEST,
  payload: businessFunctions,
});

export const fetchAssetGroups = (assetGroups) => ({
  type: FETCH_ASSET_GROUPS_REQUEST,
  payload: assetGroups,
});

export const getBusinessFunctions = (orgaId) => {
  return async (dispatch) => {
    const isCurrent = claimOrgScopedRequest("business_functions");
    dispatch(requestStarted("Fetching_business_functions"));
    // Dropped before the request leaves - see orgScopedRequest.
    dispatch(fetchBusinessFunctions([]));
    try {
      const res = await axiosInstance.get(
        `/survey/critical_business_functions/${orgaId}`
      );
      if (!isCurrent()) {
        // Superseded, but the loading counter it took on the way in still has
        // to be given back: feedbackReducer counts starts against successes and
        // the global overlay sits on the total. Returning without this leaks a
        // count the page can never get back, and it hangs until a reload.
        dispatch(requestSucceeded());
        return;
      }
      const businessFunctions = res.data;
      dispatch(fetchBusinessFunctions(businessFunctions?.business_functions));
      dispatch(requestSucceeded());
    } catch (error) {
      if (!isCurrent()) {
        // Superseded, but the loading counter it took on the way in still has
        // to be given back: feedbackReducer counts starts against successes and
        // the global overlay sits on the total. Returning without this leaks a
        // count the page can never get back, and it hangs until a reload.
        dispatch(requestSucceeded());
        return;
      }
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export function assetGroupList(bfId, orgaId) {
  return async (dispatch) => {
    try {
      dispatch(requestStarted("Fetching_asset_groups"));
      const res = await axiosInstance.get(
        `/survey/fetch-asset-groups/${bfId}/${orgaId}`
      );
      const assetGroups = res.data;
      // console.log("Asset Groups:", assetGroups);
      dispatch(fetchAssetGroups(assetGroups));
      dispatch(requestSucceeded());
      return assetGroups;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      // Handle error if needed
    }
  };
}

export function updateOrgaAssets(orgaId, data) {
  return async (dispatch) => {
    try {
      dispatch(requestStarted("Updating_business_functions"));
      const res = await axiosInstance.post(`/survey/business_function_ops`, {
        orga_id: Number(orgaId),
        ops: data,
      });
      const updatedBusinessFunctions = res.data;
      dispatch(fetchBusinessFunctions(updatedBusinessFunctions));
      dispatch(requestSucceeded());
      alertSuccess(res.data);
      return updatedBusinessFunctions;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
      // Handle error if needed
    }
  };
}
